module.exports = function (app) {
    app.controller('pages.account.physician-information', ['$scope','$cookies','brand','services','aemContent','UMSParse', 'sessionData','$window', 'coremetrics',
        function ($scope,$cookies,brand,services,aemContent, UMSParse, sessionData, $window, coremetrics) {
            $scope.errMessages = [];
            var subdepLoop = 0;
            $scope.fullMemberList = [];
            $scope.sidebar.links=[];
            $scope.backText = "Back";
            $scope.backAction = function() {
                $window.history.back();
            };
            window.$scope =$scope;
            aemContent.get('MER_POR_ERR01').then(function(response){
                $scope.errMessages[0]= response;
                return $scope.errMessages[0];
            }); //$scope.TS.MER_POR_ERR01;
            $scope.errMessages[1] = aemContent.get('MER_POR_ERR02');
            $scope.errMessages[2] = aemContent.get('MER_POR_ERR03');
            $scope.errMessages[3] = aemContent.get('MER_POR_ERR04');
            $scope.errMessages[4] = aemContent.get('MER_POR_ERR05');
            $scope.errMessages[5] = aemContent.get('MER_POR_ERR06');
            $scope.errMessages[6] = aemContent.get('MER_POR_ERR07');
            $scope.errMessages[7] = aemContent.get('MER_POR_ERR08');
            $scope.errMessages[8] = aemContent.get('MER_POR_ERR09');
            $scope.errMessages[9] = aemContent.get('MER_POR_ERR10');
            $scope.errMessages[10] = aemContent.get('MER_POR_ERR11');
            $scope.errMessages[11] = aemContent.get('MER_POR_ERR12');
            $scope.errMessages[12] = aemContent.get('MER_POR_ERR13');

            //content variables
            var MAINDEFINITION_ND = "Your Physician of Record or Primary Care Provider (PCP) takes care of your routine/preventive care, like physicals and screenings and helps to manage your health care.";
            var PCP_MAINDEFINITION = "Your Primary Care Physician (PCP) is a doctor who takes care of routine or preventive care, like physicals and immunizations, and coordinates any other care you need.";
            var POR_MAINDEFINITION = "Your Physician of Record takes care of routine/preventive care, like physicals and immunizations, and coordinates any other care you may need.";

            var piBrand = brand.current.sharedBrandCode.toLowerCase();
            var pcpFlag = ($cookies.get('PCP') == "true") ? "PCP" : "POR";
            $scope.ums = {};
            $scope.typeMember = '';
            $scope.PCPData = [];
            $scope.pcpCheck = $cookies.get('PCP');
            $scope.mainHeader = (pcpFlag == "PCP") ? "ABOUT YOUR PRIMARY CARE PHYSICIAN (PCP)" : "Physician of Record:";
            $scope.mainDefinition = (pcpFlag == "PCP") ? (piBrand === 'ndbcbs' ? MAINDEFINITION_ND : PCP_MAINDEFINITION) : (piBrand === 'ndbcbs' ? MAINDEFINITION_ND : POR_MAINDEFINITION);

            $scope.isAriaExpanded = function (user) {
                return !!(user && user.drawerOpen && user.drawerOpen === 'open');
            };
            $scope.showInput=  function(mem) {
                //	toggle ability for user to edit the input
                mem.showInput = !mem.showInput;
                // if this is POR, show cancel checkbox
                if ($scope.pcpCheck == false) {
                    mem.showCancel = true;
                }
            }
            $scope.submitButton = function(mem, index){
                if(mem.cancelCheck) {
                    $scope.cancelPOR(mem, index);
                } else {
                   $scope.submit(mem, index);
                }
            };
            $scope.submit = function(mem, index) {
                if(mem.physician.reason == "")  {
                    mem.physician.reasonIsEmpty = true;
                    mem.submission.msg = "This is a required field";
                    mem.isSubmitted = false;
                    // mem.submission.status = true;
                   // this.$apply();
                }
                if(mem.physician.currentClient == "")  {
                    mem.physician.currentClientIsEmpty = true;
                    mem.submission.msg = "This is a required field";
                    mem.isSubmitted = false;
                    // mem.submission.status = true;
                   // this.$apply();
                }

                if(mem.hasPOR == false){
                    mem.physician.reasonIsEmpty = false;
                }
                if(mem.physician.reasonIsEmpty == false && mem.physician.currentClientIsEmpty == false) {
                    if(mem.hasPOR) {
                        coremetrics.elementTag('PHYSICIAN OF RECORD CHANGE','MEMBER:ACCOUNT SETTINGS:PHYSICIAN OF RECORD');
                    }
                    else {
                        coremetrics.elementTag('PHYSICIAN OF RECORD NEW','MEMBER:ACCOUNT SETTINGS:PHYSICIAN OF RECORD');
                    }
                    var reasonSelect = document.getElementById(mem.firstName + mem.lastName);
                    var reasonText = (reasonSelect) ? reasonSelect.options[reasonSelect.selectedIndex].text : "NO PCP/POR ORIGINALLY SELECTED";
                    var reasonCode = (reasonSelect) ? reasonSelect.options[reasonSelect.selectedIndex] : "25";
                    var reasonEffDate = (reasonSelect) ? $scope.dateFix.dateStringToMMDDYYYY3(reasonFlag[reasonSelect.selectedIndex].effDate) : $scope.dateFix.mmddyyyy();
                    var reasonEffDateSlash = (reasonSelect) ? $scope.dateFix.dateStringToMMDDYYYY2(reasonFlag[reasonSelect.selectedIndex].effDate) : $scope.dateFix.mmddyyyySlash();
                    var isCurrentlyClient = (mem.physician.currentClient == "yes") ? "Y" : "N";
                    var memberFocusedOn = index;
                    var dob = mem.dob.replace(/\//g,'');
                    var mLob = mem.lob;

//                  Need to match member list with PCP Data member list
                    var correctPCPMemberIndex = 0;
                    for (var a = 0; a < $scope.PCPData.length; a++){
                        var memberChecker = $scope.fullMemberList[memberFocusedOn].ciid;
                        var pcpDataChecker = $scope.PCPData[a].ciid;
                        if(memberChecker == pcpDataChecker && mLob == $scope.PCPData[a].insuranceLineCde){
                            correctPCPMemberIndex = a;
                            break;
                        }
                    }
                    //                  set up request for validating PCP/POR
                    var argHolderOne = {
                        pcpNum: mem.physician.newID,
                        ssn: $scope.PCPData[correctPCPMemberIndex].ssn,
                        planAreaCde: $scope.PCPData[correctPCPMemberIndex].PlanAreaCde,
                        dob: $scope.PCPData[correctPCPMemberIndex].dob,
                        contractId: $cookies.get("mbrGroupNumber"),
                        insuranceLineCde: $scope.PCPData[correctPCPMemberIndex].insuranceLineCde,
                        pcpEffDte: $scope.PCPData[correctPCPMemberIndex].pcpEffDte
                    };
                    services.rbsmbl.validatePCP().postData(argHolderOne).then(function (PCPValidateData){
                        var pcpName = PCPValidateData.data.payload.pcpName;
                        if(typeof pcpName === "undefined" || pcpName.length == 0)  {
                            mem.submission.msg = PCPValidateData.data.payload.statusMessage; //"You must select a valid POR";
                            mem.isSubmitted = false;
                            mem.submission.status = true;
                        }  else {
                            mem.physician.name = PCPValidateData.data.payload.pcpName; // set pcpName for payload
                            var pcpName35Char = mem.physician.name.substr(0, 35); // temporarily truncate to 35 characters

                            var typeCheck = ($cookies.get("PCP") == "true") ? "PCP" : "POR";
                            // For PCP, old PCP effective date should be the same as the new effective date.  So, we can use the effective date returned by the Reason Code service.
                            var pcpCancelDate =  (typeCheck == "PCP") ? reasonEffDate : "";
                            var pcpCancelCode =  (typeCheck == "PCP") ? "0" : "";
                            var fixOldPcpEffDte =  $scope.dateFix.dateStringToMMDDYYYY($scope.PCPData[correctPCPMemberIndex].pcpEffDte);

                            // fix CSD intake for Portal Change PCP/POR process not processing
                            var coverageBeginDate = $scope.ums.clients()[0].groupList[0].productList[0].coverageBeginDate;
                            if(coverageBeginDate == null || coverageBeginDate== undefined || coverageBeginDate == ""){
                                coverageBeginDate = $scope.ums.clients()[0].groupList[0].productList[0].coverageConBeginDate;
                            }
                            var submitPor = {
                                "bdUserId": "B"+ $scope.ums.baseInformation().bvUserId,
                                "coveredId": $scope.fullMemberList[memberFocusedOn].ciid,
                                "contractId": $scope.PCPData[correctPCPMemberIndex].intControlId,
                                "agreementId": $scope.ums.baseInformation().agreementId,
                                "insuranceLineCde": $scope.PCPData[correctPCPMemberIndex].insuranceLineCde,
                                "ntwkId": $scope.PCPData[correctPCPMemberIndex].PlanAreaCde,
                                "dob": dob,
                                "numOfRec": "2",
                                "productInd": "",
                                "pcpInfo":  [
                                    {
                                        "type": typeCheck,
                                        "msgArea": "",
                                        "oldPcpNbr": $scope.PCPData[correctPCPMemberIndex].PCPNumber,
                                        "oldPcpName": $scope.PCPData[correctPCPMemberIndex].PCPName,
                                        "oldPcpEffDte": fixOldPcpEffDte,
                                        "oldPcpCanDte": pcpCancelDate,
                                        "oldNtwkProviderId": "",
                                        "pcpNbr": mem.physician.newID,
                                        "pcpName": pcpName35Char, //temporarily truncate to 35 chars
                                        "ntwkProviderId" : "",
                                        "pcpPreExistingInd": isCurrentlyClient,
                                        "pcpEffDte": reasonEffDate,
                                        "pcpCanDte": "",
                                        "pcpCanCde": pcpCancelCode,
                                        "pcpDenyCde": "",
                                        "blucdPrvNtwkId": $scope.PCPData[correctPCPMemberIndex].blucdPrvNtwkId,
                                        "reasonCode": reasonCode,
                                        "reasonDescription": reasonText
                                    },
                                    {
                                        "type": typeCheck,
                                        "msgArea": "",
                                        "oldPcpNbr": $scope.PCPData[correctPCPMemberIndex].PCPNumber,
                                        "oldPcpName": $scope.PCPData[correctPCPMemberIndex].PCPName,
                                        "oldPcpEffDte": fixOldPcpEffDte,
                                        "oldPcpCanDte": pcpCancelDate,
                                        "oldNtwkProviderId": "",
                                        "pcpNbr": mem.physician.newID,
                                        "pcpName": pcpName35Char, //temporarily truncate to 35 chars
                                        "ntwkProviderId" : "",
                                        "pcpPreExistingInd": isCurrentlyClient,
                                        "pcpEffDte": reasonEffDate,
                                        "pcpCanDte": "",
                                        "pcpCanCde": pcpCancelCode,
                                        "pcpDenyCde": "",
                                        "blucdPrvNtwkId": $scope.PCPData[correctPCPMemberIndex].blucdPrvNtwkId,
                                        "reasonCode": reasonCode,
                                        "reasonDescription": reasonText
                                    }
                                ],
                                "intakeRequest": {
                                    "bdUserId": "B"+ $scope.ums.baseInformation().bvUserId,
                                    //"date": ,
                                    //"languageCode": "EN",
                                    //"channelCode": "IS",
                                    "contactFirstName": $scope.fullMemberList[memberFocusedOn].firstName,
                                    "contactMiddleName": $scope.fullMemberList[memberFocusedOn].middleName,
                                    "contactLastName": $scope.fullMemberList[memberFocusedOn].lastName,
                                    "memberFirstName": $scope.fullMemberList[memberFocusedOn].firstName,
                                    "memberMiddleName": $scope.fullMemberList[memberFocusedOn].middleName,
                                    "memberLastName": $scope.fullMemberList[memberFocusedOn].lastName,
                                    "birthDate": mem.dob,
                                    "gender": $scope.fullMemberList[memberFocusedOn].gender,
                                    //"subscriberFirstName": "",
                                    //"subscriberMiddleName": "",
                                    //"subscriberLastName": "",
                                    "relationshipCode": $scope.fullMemberList[memberFocusedOn].relationshipCode,
                                    "enrollmentSourceCode": $scope.ums.clients()[0].enrollmentSourceCode,
                                    //"websiteCode": "HMBCBS",
                                    //"brandCode": "HMBCBS",
                                    "ecId": $scope.fullMemberList[memberFocusedOn].ecId,
                                    "umi": $scope.ums.baseInformation().umi,
                                    "lob": $scope.PCPData[correctPCPMemberIndex].insuranceLineCde,
                                    //"lobType": "PPO BLUE", // get
                                    "alphaPrefix": $scope.ums.clients()[0].groupList[0].productList[0].alphaPrefix,
                                    "groupNumber": $scope.fullMemberList[memberFocusedOn].groupNumber,
                                    "benefitPlanName": $scope.ums.clients()[0].groupList[0].productList[0].benefitPlanName,
                                    // "coverageBeginDate": $scope.ums.clients()[0].groupList[0].productList[0].coverageBeginDate,
                                    "coverageBeginDate":coverageBeginDate,
                                    "coverageEndDate": $scope.ums.clients()[0].groupList[0].productList[0].coverageEndDate,
                                    "agreementId": $scope.ums.baseInformation().agreementId,
                                    "clientName": $scope.ums.clients()[0].clientName,
                                    "clientId": $scope.ums.clients()[0].clientId,
                                    "coveredIndividualId": $scope.fullMemberList[memberFocusedOn].ciid,
                                    "internalGroupNumber": $scope.ums.fullGroupList()[0].internalGroupNumber
                                }
                            };

                            // var deferChange = new Deferred();
                            mem.submitDisabled = true;  // immediately disable submit to prevent double entry.
                            mem.cancelDisabled = true;
                            // mem.physician.name = PCPValidateData.data.payload.pcpName; // set pcpName for payload
                            services.rbsmbl.providerChange().saveData(submitPor).then(function(changeData){
                                var denyCode = changeData.data.payload.pcpInfo[0].pcpDenyCde;
                                mem.submission.msg = "You will receive an updated ID card in 5-10 business days. Your new PCP will be effective on " + reasonEffDateSlash + ".";
                                if((typeCheck == "POR" && denyCode != "000") || (typeCheck == "PCP" && denyCode != "")) {
                                    switch(denyCode) {
                                        // todo: rename these into constants for readability
                                        // todo: put all error messages into content management and conditionally display them in html
                                        case "004":
                                            //mem.submission.msg = "The physician you have chosen is not accepting new patients at this time. Please choose another physician.";
                                            mem.submission.msg = errMessages[0];
                                            mem.isSubmitted = false;
                                            mem.submission.status = true;
                                            mem.submitDisabled = false;
                                           // this.$apply();
                                            break;
                                        case "005":
                                            //mem.submission.msg = "Sorry, we are unable to process your request.  The member is over the age limit for the selected PCP.";
                                            mem.submission.msg = errMessages[1];
                                            mem.isSubmitted = false;
                                            mem.submission.status = true;
                                            mem.submitDisabled = false;
                                            //this.$apply();
                                            break;
                                        case "006":
                                            //mem.submission.msg = "Sorry, we are unable to process your request.  The member is under the age limit for the selected PCP.";
                                            mem.submission.msg = errMessages[2];
                                            mem.isSubmitted = false;
                                            mem.submission.status = true;
                                            mem.submitDisabled = false;
                                            //this.$apply();
                                            break;
                                        case "007":
                                            //mem.submission.msg = "Sorry, we are unable to process your request.  The PCP is accepting existing patients only.";
                                            mem.submission.msg = errMessages[3];
                                            mem.isSubmitted = false;
                                            mem.submission.status = true;
                                            mem.submitDisabled = false;
                                            //this.$apply();
                                            break;
                                        case "008":
                                            //mem.submission.msg = "Sorry, we are unable to process your request.  The office is closed to all patients.";
                                            mem.submission.msg = errMessages[4];
                                            mem.isSubmitted = false;
                                            mem.submission.status = true;
                                            mem.submitDisabled = false;
                                           // this.$apply();
                                            break;
                                        case "009":
                                            //mem.submission.msg = "Sorry, we are unable to process your request.  This physician is not a PCP.";
                                            mem.submission.msg = errMessages[5];
                                            mem.isSubmitted = false;
                                            mem.submission.status = true;
                                            mem.submitDisabled = false;
                                           // this.$apply();
                                            break;
                                        case "010":
                                            //mem.submission.msg = "Sorry, we are unable to process your request.  This physician is not active.";
                                            mem.submission.msg = errMessages[6];
                                            mem.isSubmitted = false;
                                            mem.submission.status = true;
                                            mem.submitDisabled = false;
                                           // this.$apply();
                                            break;
                                        case "011":
                                            //mem.submission.msg = "Sorry, we are unable to process your request.  The member does not have a birthdate on file.";
                                            mem.submission.msg = errMessages[7];
                                            mem.isSubmitted = false;
                                            mem.submission.status = true;
                                            mem.submitDisabled = false;
                                           // this.$apply();
                                            break;
                                        case "012":
                                            //mem.submission.msg = "We are having problems saving your physician at this time. Please try again later. Contact us if this problem continues.";
                                            mem.submission.msg = errMessages[8];
                                            mem.isSubmitted = false;
                                            mem.submission.status = true;
                                            mem.submitDisabled = false;
                                           // this.$apply();
                                            break;
                                        case "013":
                                            //mem.submission.msg = "We are having problems saving your physician at this time. Please try again later. Contact us if this problem continues.";
                                            mem.submission.msg = errMessages[9];
                                            mem.isSubmitted = false;
                                            mem.submission.status = true;
                                            mem.submitDisabled = false;
                                           // this.$apply();
                                            break;
                                        case "020":
                                            //mem.submission.msg = "The physician you have chosen is not in our network. Please choose another physician.";
                                            mem.submission.msg = errMessages[10];
                                            mem.isSubmitted = false;
                                            mem.submission.status = true;
                                            mem.submitDisabled = false;
                                          //  this.$apply();
                                            break;
                                        case "002":
                                            //mem.submission.msg = "Sorry, we are unable to process your request.  The PCP Number can not be greater than 6 positions.";
                                            mem.submission.msg = errMessages[11];
                                            mem.isSubmitted = false;
                                            mem.submission.status = true;
                                            mem.submitDisabled = false;
                                           // this.$apply();
                                            break;
                                        default:
                                            //mem.submission.msg = "We are having problems saving your physician at this time. Please try again later. Contact us if this problem continues.";
                                            mem.submission.msg = errMessages[12];
                                            mem.isSubmitted = false;
                                            mem.submission.status = true;
                                            mem.submitDisabled = false;
                                           // this.$apply();
                                    }
                                }
                                else {
                                    mem.isSubmitted = true;
                                    mem.physician.currentClientIsEmpty = false;
                                    mem.physician.reasonIsEmpty = false;
                                    mem.submission.status = false;
                                   // this.$apply();
                                }
                            }, function(error){
                                //TODO: This used to be a console.log. It doesn't seem like anything happens as a consequence of the promise's failing.
                            });

                        }
                    });
                }
            }
            $scope.cancelPOR = function(mem, index){
                var memberFocusedOn = index;
                var dob = mem.dob.replace(/\//g,'');
                var mLob = mem.lob;

//              Need to match member list with PCP Data member list
                var correctPCPMemberIndex = 0;
                for (var a = 0; a < $scope.PCPData.length; a++){
                    var memberChecker = $scope.fullMemberList[memberFocusedOn].ciid;
                    var pcpDataChecker = $scope.PCPData[a].ciid;
                    if(memberChecker == pcpDataChecker && mLob == $scope.PCPData[a].insuranceLineCde){
                        correctPCPMemberIndex = a;
                        break;
                    };
                }
                var fixOldPcpEffDte =  $scope.dateFix.dateStringToMMDDYYYY($scope.PCPData[correctPCPMemberIndex].pcpEffDte);

                var cancelPORPayload = {
                    "bdUserId": "B"+ $scope.ums.baseInformation().bvUserId,
                    "coveredId": $scope.fullMemberList[memberFocusedOn].ciid,
                    "contractId": $scope.PCPData[correctPCPMemberIndex].intControlId,
                    "agreementId":$scope.ums.baseInformation().agreementId,
                    "insuranceLineCde": $scope.PCPData[correctPCPMemberIndex].insuranceLineCde,
                    "ntwkId": $scope.PCPData[correctPCPMemberIndex].PlanAreaCde,
                    "dob": dob,
                    "numOfRec": "2",
                    "productInd": "",
                    "pcpInfo":  [
                        {
                            "type": "POR_CANCEL",
                            "msgArea": "",
                            "oldPcpNbr": $scope.PCPData[correctPCPMemberIndex].PCPNumber,
                            "oldPcpName": $scope.PCPData[correctPCPMemberIndex].PCPName,
                            "oldPcpEffDte": fixOldPcpEffDte,
                            "oldPcpCanDte": "",
                            "oldNtwkProviderId": "",
                            "pcpNbr": "",
                            "pcpName": "",
                            "ntwkProviderId" : "",
                            "pcpPreExistingInd": "",
                            "pcpEffDte": "",
                            "pcpCanDte": "",
                            "pcpCanCde": "",
                            "pcpDenyCde": "",
                            "blucdPrvNtwkId": "",
                            "reasonCode": "28",
                            "reasonDescription": "Other"
                        },
                        {
                            "type": "POR_CANCEL",
                            "msgArea": "",
                            "oldPcpNbr": $scope.PCPData[correctPCPMemberIndex].PCPNumber,
                            "oldPcpName": $scope.PCPData[correctPCPMemberIndex].PCPName,
                            "oldPcpEffDte": fixOldPcpEffDte,
                            "oldPcpCanDte": "",
                            "oldNtwkProviderId": "",
                            "pcpNbr": "",
                            "pcpName": "",
                            "ntwkProviderId" : "",
                            "pcpPreExistingInd": "",
                            "pcpEffDte": "",
                            "pcpCanDte": "",
                            "pcpCanCde": "",
                            "pcpDenyCde": "",
                            "blucdPrvNtwkId": "",
                            "reasonCode": "28",
                            "reasonDescription": "Other"
                        }
                    ],
                    "intakeRequest": {
                        "bdUserId": "B"+ $scope.ums.baseInformation().bvUserId,
                        "contactFirstName": $scope.fullMemberList[memberFocusedOn].firstName,
                        "contactMiddleName": $scope.fullMemberList[memberFocusedOn].middleName,
                        "contactLastName": $scope.fullMemberList[memberFocusedOn].lastName,
                        "memberFirstName": $scope.fullMemberList[memberFocusedOn].firstName,
                        "memberMiddleName": $scope.fullMemberList[memberFocusedOn].middleName,
                        "memberLastName": $scope.fullMemberList[memberFocusedOn].lastName,
                        "birthDate": mem.dob,
                        "gender": $scope.fullMemberList[memberFocusedOn].gender,
                        "relationshipCode": $scope.fullMemberList[memberFocusedOn].relationshipCode,
                        "enrollmentSourceCode": $scope.ums.clients()[0].enrollmentSourceCode,
                        "ecId": $scope.fullMemberList[memberFocusedOn].ecId,
                        "umi": $scope.ums.baseInformation().umi,
                        "lob": PCPData[correctPCPMemberIndex].insuranceLineCde,
                        "alphaPrefix": $scope.ums.clients()[0].groupList[0].productList[0].alphaPrefix,
                        "groupNumber": $scope.fullMemberList[memberFocusedOn].groupNumber,
                        "benefitPlanName": $scope.ums.clients()[0].groupList[0].productList[0].benefitPlanName,
                        "coverageBeginDate": $scope.ums.clients()[0].groupList[0].productList[0].coverageBeginDate,
                        "coverageEndDate": $scope.ums.clients()[0].groupList[0].productList[0].coverageEndDate,
                        "agreementId": $scope.ums.baseInformation().agreementId,
                        "clientName": $scope.ums.clients()[0].clientName,
                        "clientId": $scope.ums.clients()[0].clientId,
                        "coveredIndividualId": $scope.fullMemberList[memberFocusedOn].ciid,
                        "internalGroupNumber": $scope.ums.fullGroupList()[0].internalGroupNumber
                    }
                };
                mem.submitDisabled = true;  // immediately disable submit to prevent double entry.
                mem.cancelDisabled = true;
                services.rbsmbl.providerChange().saveData(cancelPORPayload).then(function(changeData){
                    var denyCode = changeData.data.payload.pcpInfo[0].pcpDenyCde;
                    if(denyCode != "000") {
                                mem.submission.msg = "We are unable to process your request to change or remove your Physician of Record. Please try again later.";
                                mem.cancelSubmitted = false;
                                mem.submission.fail = true;
                                mem.submitDisabled = false;
                    }
                    else {
                        mem.submission.msg = "If you do not see your changes right away, check back soon. Your update will appear as soon as it is processed.";
                        mem.cancelSubmitted = true;
                        mem.physician.currentClientIsEmpty = false;
                        mem.physician.reasonIsEmpty = false;
                        mem.submission.fail = false;

                    }
                },  function(error) {
                    mem.submitDisabled = false;
                    mem.cancelDisabled = false;
                });
            };
            $scope.openProviderSearch = function(mem, index) {
                // we're toggling PVD integration with App Config here. If false, go to Prism
                var pcpBoolean = ($cookies.get("PCP") == "true") ? true : false;
                var pvdIntegration = (sessionData && sessionData.appConfig && sessionData.appConfig.ACCOUNT_SETTINGS && sessionData.appConfig.ACCOUNT_SETTINGS.PVD_INTEGRATION && sessionData.appConfig.ACCOUNT_SETTINGS.PVD_INTEGRATION.booleanValue) ? true : false;
                if (pvdIntegration) {
                    var pvdURL = "/find-a-doctor/#/home?pcpIndex=" + index + "&pcp=" + pcpBoolean + "&returnUrl=" + location.host  + "/member/account/pi";
                    location.href = pvdURL;
                } else {
                    var root = location.protocol + '//' + location.host;
                    location.href = root + '/chmptl/chm/jsp/providerSearchLink.do?isChangePCP=true&porMember=true&porMemIndex=' + index + '&cm_sp=external%20link-_-provider%20directory-_-find%20a%20provider';
                }
            };
            $scope.clearAlert = function(mem) {
                mem.physician.currentClientIsEmpty.value = false;
                mem.physician.reasonIsEmpty.value = false;
            };
            $scope.disableChangeElements  = function(mem){
                var reasonSelecter = mem.firstName+mem.lastName;
                document.getElementById("docName-"+mem.ciid).classList.add("disabled-gray");
                document.getElementById("docIDLabel-"+mem.ciid).classList.add("disabled-gray");
                document.getElementById("docNameLabel-"+mem.ciid).classList.add("disabled-gray");
                document.getElementById("docSearchText-"+mem.ciid).classList.add("disabled-gray");
                document.getElementById("docSearchLink-"+mem.ciid).classList.add("disabled-gray");
                document.getElementById("docQuestion-"+mem.ciid).classList.add("disabled-gray");
                document.getElementById("docQuestionLabelYes-"+mem.ciid).classList.add("disabled-gray");
                document.getElementById("docQuestionLabelNo-"+mem.ciid).classList.add("disabled-gray");
                document.getElementById("reasonChangeText-"+mem.ciid).classList.add("disabled-gray");

                document.getElementById("docNewID-"+mem.ciid).setAttribute("disabled","disabled");

                document.getElementById("docQuestionYes-"+mem.ciid).setAttribute("disabled","disabled");
                document.getElementById("docQuestionNo-"+mem.ciid).setAttribute("disabled","disabled");
                document.getElementById(reasonSelecter).setAttribute("disabled","disabled");
                mem.submitDisabled = mem.isSubmitted;
            };
            $scope.enableChangeElements = function(mem){
                var reasonSelecter = mem.firstName+mem.lastName;
                document.getElementById("docName-"+mem.ciid).classList.remove("disabled-gray");
                document.getElementById("docIDLabel-"+mem.ciid).classList.remove("disabled-gray");
                document.getElementById("docNameLabel-"+mem.ciid).classList.remove("disabled-gray");
                document.getElementById("docSearchText-"+mem.ciid).classList.remove("disabled-gray");
                document.getElementById("docSearchLink-"+mem.ciid).classList.remove("disabled-gray");
                document.getElementById("docQuestion-"+mem.ciid).classList.remove("disabled-gray");
                document.getElementById("docQuestionLabelYes-"+mem.ciid).classList.remove("disabled-gray");
                document.getElementById("docQuestionLabelNo-"+mem.ciid).classList.remove("disabled-gray");
                document.getElementById("reasonChangeText-"+mem.ciid).classList.remove("disabled-gray");

                document.getElementById("docNewID-"+mem.ciid).removeAttribute("disabled");

                document.getElementById("docQuestionYes-"+mem.ciid).removeAttribute("disabled");
                document.getElementById("docQuestionNo-"+mem.ciid).removeAttribute("disabled");
                document.getElementById(reasonSelecter).removeAttribute("disabled");

                mem.submitDisabled = true;
            }
            $scope.setCancelCheck = function(mem){
                mem.cancelCheck = !mem.cancelCheck;
                if(mem.cancelCheck) {
                    this.disableChangeElements(mem);
                }
                else{
                    this.enableChangeElements(mem);
                };
            }
            $scope.changeCancel = function(mem){
                mem.showCancel = false;
                mem.showInput = false;
                mem.physician.newID = "";
                mem.cancelCheck = false;
                mem.submission.fail = false;
                mem.submitDisabled = true;

                this.enableChangeElements(mem);
            }
            $scope.disableEnableButton = function(mem) {
                //	submit button should only be enabled when a valid input is entered, and disabled otherwise
                //	prior to submission, valid means a nine digit string, numeric only
                var re = /^\d{9}$/;
                var str = mem.physician.newID;
                if(str){
                    if (str.match(re)  && cancelledAccount == false)
                    mem.submitDisabled = false;
                }
                else {
                    mem.submitDisabled = true;
                }
            };

            $scope.dateFix = {
                mmddyyyy: function () {
                    var dateIn = new Date();
                    var yyyy = dateIn.getFullYear();
                    var mm = dateIn.getMonth() + 1; // getMonth() is zero-based
                    var dd = dateIn.getDate();
                    var preParse = String(10000 * yyyy + 100 * mm + dd); // Leading zeros for mm and dd
                    var yearHolder = preParse.substring(0, 4);
                    var dayDateHolder = preParse.substring(4, 8);
                    preParse = dayDateHolder + yearHolder;
                    return preParse;
                },
                mmddyyyySlash: function () {
                    var dateIn = new Date();
                    var yyyy = dateIn.getFullYear();
                    var mm = dateIn.getMonth() + 1; // getMonth() is zero-based
                    var dd = dateIn.getDate();
                    var preParse = String(10000 * yyyy + 100 * mm + dd); // Leading zeros for mm and dd
                    var yearHolder = preParse.substring(0, 4);
                    var monthHolder = preParse.substring(4, 6);
                    var dayDateHolder = preParse.substring(6, 8);
                    preParse = monthHolder + "/" + dayDateHolder + "/" + yearHolder;
                    return preParse;
                },
                dateStringToMMDDYYYY: function (str) {
                    if (str !== "") {
                        var dateArray = str.split("-");
                        var year = dateArray[0];
                        var month = dateArray[1];
                        var day = dateArray[2];
                        var fixedDate = month + day + year;
                        return fixedDate;
                    } else {
                        return "";
                    }
                },
                dateStringToMMDDYYYYDash: function (str) {
                    if (str !== "") {
                        var dateArray = str.split("-");
                        var year = dateArray[0];
                        var month = dateArray[1];
                        var day = dateArray[2];
                        var fixedDate = month + "/" + day + "/" + year;
                        return fixedDate;
                    } else {
                        return "";
                    }
                },
                dateStringToMMDDYYYY2: function (str) {
                    if (str !== "") {
                        var dateArray = str.split("/");
                        var year = dateArray[0];
                        var month = dateArray[1];
                        var day = dateArray[2];
                        var fixedDate = month + "/" + day + "/" + year;
                        return fixedDate;
                    } else {
                        return "";
                    }
                },
                dateStringToMMDDYYYY3: function (str) {
                    if (str !== "") {
                        var dateArray = str.split("/");
                        var year = dateArray[0];
                        var month = dateArray[1];
                        var day = dateArray[2];
                        var fixedDate = month + day + year;
                        return fixedDate;
                    } else {
                        return "";
                    }
                },
                yyyymmdd: function () {
                    var dateIn = new Date();
                    var yyyy = dateIn.getFullYear();
                    var mm = dateIn.getMonth() + 1; // getMonth() is zero-based
                    var dd = dateIn.getDate();
                    var preParse = String(10000 * yyyy + 100 * mm + dd); // Leading zeros for mm and dd
                    var yearHolder = preParse.substring(0, 4);
                    var monthHolder = preParse.substring(4, 6);
                    var dayDateHolder = preParse.substring(6, 8);
                    preParse = yearHolder + "/" + monthHolder + "/" + dayDateHolder;
                    return preParse;
                }
            }
//	The preRender is a pretty heavy duty routine which calls nested services that will in the end,
//  either get the PCPName/PCPNumber as well as all other vitals to the submit process (if that happens)
//  depending on if they are a subscriber member or a dependent member.
            services.rbsmbl.memberInfo().fetch().then(function (fullMemberInfo) {

                $scope.typeMember = fullMemberInfo.data.payload.emktUserType;
                console.log("type member: ", $scope.typeMember);
                var groupNo = fullMemberInfo.data.payload.clientList[0].groupList[0].groupNumber;
                //$scope.ums = fullMemberInfo.data.payload;
                $scope.fullMemberList = [];

                // $scope.fullMemberList = services.rbsmbl.memberInfo().getUniqueMemberNamesArray(fullMemberInfo.data.payload);
                console.log("full member list:", $scope.fullMemberList);
                var serverDate = new Date();
                $scope.ums = new UMSParse(fullMemberInfo.data.payload, serverDate);

                var len, found;
                len =  $scope.ums.fullMemberList().length;
                var tGnum = $cookies.get("mbrGroupNumber");
                for (loopOne = 0; loopOne < len; ++loopOne) {
                    var holderMemberName =  $scope.ums.fullMemberList()[loopOne].firstName;
                    var holderDOB =  $scope.ums.fullMemberList()[loopOne].dob;
                    found = false;
                    for (var loopTwo = 0; !found && (loopTwo < len); loopTwo++) {
                        if (holderMemberName ===  $scope.ums.fullMemberList()[loopTwo].firstName && holderDOB ===  $scope.ums.fullMemberList()[loopTwo].dob && tGnum ==  $scope.ums.fullMemberList()[loopTwo].groupNumber) {
                            if (loopOne === loopTwo) {
                                $scope.fullMemberList.push( $scope.ums.fullMemberList()[loopTwo]);
                            }
                            found = true;
                        }
                    }
                }

                var clientLen = $scope.fullMemberList.length;
                if (clientLen == 1 && $scope.fullMemberList[0].relationship == "Subscriber") {
                    var loopSubDepTimes = 1;
                }
                else {
                    if (clientLen == 1 && ($scope.fullMemberList[0].relationship == "Dependent" || $scope.fullMemberList[0].relationship == "Spouse")) {
                        var loopSubDepTimes = 1;
                    } else {
                        var loopSubDepTimes = 2;
                    }
                }
                subdepLoop = 0;
                for (var loopOne = 0; loopOne < loopSubDepTimes; ++loopOne) {
                    var firstName = $scope.fullMemberList[loopOne].firstName.toUpperCase();
                    var argHolderOne = {
                        memberId:  $scope.ums.baseInformation().umi,
                        memberIdType: "UMI",
                        dob: $scope.fullMemberList[loopOne].dob,
                        firstName: firstName
                    };
                    services.rbsmbl.memberProfile().fetch(argHolderOne).then(function (memberProfileData) {
                        var mbrGroupNumberCookie = $cookies.get("mbrGroupNumber");
                        var mbrGroupEffectiveDateCookie = $cookies.get("mbrGroupEffectiveDate");
                        var memberProfileIndex;
//						Right now we are finding the right profile only based on contractId - we might need to narrow down more...
                        for (var loopTwo = 0; loopTwo < memberProfileData.data.payload.memberProfile.length; ++loopTwo) {
                            if (memberProfileData.data.payload.memberProfile[loopTwo].contractId == mbrGroupNumberCookie) {
                                memberProfileIndex = loopTwo;
                                break;
//								We match the cookie with the service response here
                            }
                        }
                        if (typeof memberProfileIndex !== 'undefined') {
                            var intControlId = memberProfileData.data.payload.memberProfile[memberProfileIndex].intContractId;
                            var planAreaCde = memberProfileData.data.payload.memberProfile[memberProfileIndex].planAreaCde;
                            //var clientMemberList = ums.removeDuplicatesMembersWithoutDates();
                            var agreementNumber = memberProfileData.data.payload.memberProfile[memberProfileIndex].agrNbr;
                            var contractHolderId = memberProfileData.data.payload.memberProfile[memberProfileIndex].contractHolderId;
                            var clientId = memberProfileData.data.payload.memberProfile[memberProfileIndex].clientId;
                            var clientName = memberProfileData.data.payload.memberProfile[memberProfileIndex].clientName;
                            var contractId = memberProfileData.data.payload.memberProfile[memberProfileIndex].contractId;
                            var internalContractId = memberProfileData.data.payload.memberProfile[memberProfileIndex].intContractId;
//						We need the below variables for the submit criteria - it is why they are global and included...
                            var insuranceLineCde = memberProfileData.data.payload.memberProfile[memberProfileIndex].insuranceLineCde;
                            if ($scope.fullMemberList[subdepLoop].relationship == "Subscriber") {
                                var argHolderTwo = {
                                    agreementNumber: memberProfileData.data.payload.memberProfile[memberProfileIndex].agrNbr,
                                    contractHolderId: memberProfileData.data.payload.memberProfile[memberProfileIndex].contractHolderId,
                                    clientId: memberProfileData.data.payload.memberProfile[memberProfileIndex].clientId,
                                    clientName: memberProfileData.data.payload.memberProfile[memberProfileIndex].clientName,
                                    contractId: memberProfileData.data.payload.memberProfile[memberProfileIndex].contractId,
                                    internalContractId: memberProfileData.data.payload.memberProfile[memberProfileIndex].intContractId,
                                    productIndicator: ""
                                };
//							Call the subscriber service so we can get their specific pcpNbr/Name as well as items needed for submit.
                                services.rbsmbl.subscriberPCP().fetch(argHolderTwo).then(function (PCPSubscriberData) {
                                    var argHolderThree = {
                                        PCPNumber: PCPSubscriberData.data.payload.pcpNbr,
                                        PCPName: PCPSubscriberData.data.payload.pcpName,
                                        insuranceLineCde: PCPSubscriberData.data.payload.insuranceLineCde,
                                        groupNo: groupNo,
                                        intControlId: intControlId,
                                        numOfRec: 1,
                                        PlanAreaCde: planAreaCde,
                                        pcpEffDte: PCPSubscriberData.data.payload.pcpEffectiveDate,
                                        blucdPrvNtwkId: PCPSubscriberData.data.payload.blucdPrvNtwkId,
                                        ntwkId: PCPSubscriberData.data.payload.ntwkId,
                                        ssn: memberProfileData.data.payload.memberProfile[memberProfileIndex].ssn,
                                        dob: PCPSubscriberData.data.payload.dob10Char,
                                        fName: PCPSubscriberData.data.payload.firstName,
                                        lName: PCPSubscriberData.data.payload.lastName,
                                        mName: PCPSubscriberData.data.payload.middleName,
                                        ciid: PCPSubscriberData.data.payload.coveredIndivId
                                    };
                                    // Rule - if ntwkId == "" then replace the value with planAreaCde
                                    argHolderThree.ntwkId = (argHolderThree.ntwkId == "") ? argHolderThree.PlanAreaCde : argHolderThree.ntwkId;
//								Push the data so it is available to the model and submit information.
                                    $scope.PCPData.push(argHolderThree);
//                              If we don't resolve/populate here and there is only one subscriber, it won't get done!
                                    if (loopSubDepTimes == 1) {
                                       // defer.resolve();
                                        $scope.start();
                                        //$scope.$apply();
                                    }
                                }, function (error) {
                                    //TODO: This used to be a console.log. It doesn't seem like anything happens as a consequence of this promise's failing.
                                });
                            } else {   // if dependent call this service...
                                var argHolderTwo = {
                                    agreementNumber: agreementNumber,
                                    contractHolderId: contractHolderId,
                                    clientId: clientId,
                                    clientName: clientName,
                                    contractId: contractId,
                                    internalContractId: internalContractId,
                                    productIndicator: ""
                                };
                                //							Call the dependent service so we can get their specific pcpNbr/Name as well as items needed for submit.
                                services.rbsmbl.dependentPCP().fetch(argHolderTwo).then(function (PCPDependentData) {
                                    for (var loopThree = 0; loopThree < PCPDependentData.data.payload.length; ++loopThree) {
                                        var argHolderThree = {
                                            PCPNumber: PCPDependentData.data.payload[loopThree].pcpNbr,
                                            PCPName: PCPDependentData.data.payload[loopThree].pcpName,
                                            insuranceLineCde: PCPDependentData.data.payload[loopThree].insuranceLineCde,
                                            groupNo: groupNo,
                                            intControlId: intControlId,
                                            numOfRec: 1,
                                            PlanAreaCde: planAreaCde,
                                            pcpEffDte: PCPDependentData.data.payload[loopThree].pcpEffectiveDate,
                                            blucdPrvNtwkId: PCPDependentData.data.payload[loopThree].blucdPrvNtwkId,
                                            ntwkId: PCPDependentData.data.payload[loopThree].ntwkId,
                                            ssn: memberProfileData.data.payload.memberProfile[memberProfileIndex].ssn,
                                            dob: PCPDependentData.data.payload[loopThree].dob10Char,
                                            fName: PCPDependentData.data.payload[loopThree].firstName,
                                            lName: PCPDependentData.data.payload[loopThree].lastName,
                                            mName: PCPDependentData.data.payload[loopThree].middleName,
                                            ciid: PCPDependentData.data.payload[loopThree].coveredIndivId
                                        };
//									Rule - if ntwkId == "" then replace the value with planAreaCde
                                        argHolderThree.ntwkId = (argHolderThree.ntwkId == "") ? argHolderThree.PlanAreaCde : argHolderThree.ntwkId;
//									Push the data so it is available to the model and submit information.
                                        $scope.PCPData.push(argHolderThree);
                                    }
                                   // defer.resolve();
                                    $scope.start();
                                    //$scope.$apply();
//	                        PCPDependent service error handling:
                                }, function (error) {
                                    //TODO: This used to be a console.log. It doesn't seem like anything happens as a consequence of the promise's failing.
                                });
                            }
                        }
                        subdepLoop++;
                        // serverdate service error handling:
                    }, function (error) {
                        //TODO: This used to be a console.log. It doesn't seem like anything happens as a consequence of the promise's failing
                    });

                }
                // memberInfo service error handling:
            }, function (error) {
                //TODO: This used to be a console.log. It doesn't seem like anything happens as a consequence of this promise's failing
            });

            var typeCheck = ($cookies.get("PCP") == "true") ? "PCP" : "POR";

            var reasonParams = {
                asOfDate: $scope.dateFix.yyyymmdd(),
                groupNumber: $cookies.get("mbrGroupNumber"),
                type: typeCheck
            };
            services.rbsmbl.pcpCancelReasonCodes().fetch(reasonParams).then(function(changeReasonData) {

                var reasonServiceReturn = [];
                for(var i = 0; i < changeReasonData.data.payload.pcpReasonCode.length; i++){
                    var thisReason = changeReasonData.data.payload.pcpReasonCode[i];
                    var thisEffectiveDate = thisReason.effectiveDate;
                    var thisreasonCode = thisReason.reasonCode;
                    var thisreasonDesc = thisReason.reasonDesc;
                    reasonServiceReturn.push(Object.assign({}, {
                        label : thisreasonDesc,
                        value : thisreasonCode,
                        effDate : thisEffectiveDate
                    }, thisReason));
                }

                $scope.changeReasons = angular.copy(reasonServiceReturn);
                reasonFlag = angular.copy(reasonServiceReturn);

            }, function (error) {
                //TODO: This used to be a console.log. It doesn't seem like anything happens as a consequence of this promise's failing
            });
            //We need to parse if coming from PRISM so we can populate the model properly later.
                var netRef = location.href;
            if( (netRef.indexOf("?") != -1) && (netRef.indexOf("cm_mc_uid") == -1) ) {  // if we are coming from PRISM (not CM)  - parse
                var netAryPrimary = [], netArySecondary = [], netAryTertiary = [];
                netAryPrimary = netRef.split("?");
                netRef = netAryPrimary[1];
                netAryPrimary = netRef.split("=");
                netRef = netAryPrimary[1];
                netArySecondary = netRef.split("&");
                netRef = netAryPrimary[3];
                netAryTertiary = netRef.split("&");
                PCPIndex = netAryTertiary[0];
                PCPfromPRISM = netArySecondary[0];
                netAryPrimary = netAryPrimary[2].split("&");
                PCPDocNamefromPRISM = netAryPrimary[0];
                if (PCPDocNamefromPRISM) {
                    PCPDocNamefromPRISM = decodeURIComponent(PCPDocNamefromPRISM.replace(/\+/g, " "));
                    providerSelected = true;
                }
            }
            $scope.queryString = function () {
                var queryString = {};
                var query = window.location.search.substring(1);
                var vars = query.split("&");
                for (var i=0;i<vars.length;i++) {
                    var pair = vars[i].split("=");
//			If first entry with this name
                    if (typeof queryString[pair[0]] === "undefined") {
                        queryString[pair[0]] = pair[1];
//				If second entry with this name
                    } else if (typeof queryString[pair[0]] === "string") {
                        var arr = [ queryString[pair[0]], pair[1] ];
                        queryString[pair[0]] = arr;
//				If third or later entry with this name
                    } else {
                        queryString[pair[0]].push(pair[1]);
                    }
                }
                return queryString;
            }

            $scope.start = function() {
                // pull a few nodes off ums for parsing
                var mbrList = $scope.fullMemberList;
                var prodList = $scope.ums.fullProductList();
                var umi = $scope.ums.baseInformation().umi;

                // Our Member List and our PCP Data list sometimes have a different order of members.  Must put these in the same order in order to send the change data correctly.  The sort functions below use ciid as a value to do numeric ordering.

                mbrList.sort(function(a, b){
                    if(a.ciid > b.ciid){
                        return 1;
                    }
                    if(a.ciid < b.ciid){
                        return -1;
                    }
                });
                $scope.PCPData.sort(function(a, b){
                    if(a.ciid > b.ciid){
                        return 1;
                    }
                    if(a.ciid < b.ciid){
                        return -1;
                    }
                });

                // create your array of members
                var mbrArr = [];
                var showable;

                for (var i = 0; i < mbrList.length; i++) {
                    var alphaPrefix = '';
                    var mbrLOB = 0;
                    for (var j = 0; j < prodList.length; j++) {
                        // If you are parsing over the current medical plan with a valid alphaPrefix,
                        // then you have found the correct alphaPrefix
                        if (prodList[j].benefitPlanType === "Medical"
                            && Date.parse(prodList[j].coverageBeginDate) < Date.now()
                            && Date.now() < Date.parse(prodList[j].coverageEndDate)
                            && prodList[j].alphaPrefix !== null) {
//                   console.log("alpha:",prodList[j]);
                            alphaPrefix = prodList[j].alphaPrefix;
                            mbrLOB = prodList[j].lob;
                        }
                    }

                    var correctPCPMemberIndex = 0;

                    for (var a = 0; a < $scope.PCPData.length; a++){
                        var memberChecker = mbrList[i].ciid;
                        var pcpDataChecker = $scope.PCPData[a].ciid;
                        var pcpLOB = $scope.PCPData[a].insuranceLineCde;
                        if(memberChecker == pcpDataChecker && mbrLOB == pcpLOB){
                            correctPCPMemberIndex = a;
                            break;
                        };
                    }

                    if($scope.typeMember != "member" && i == 0) {
                        showable = false;
                    }
                    else {
                        showable = true;
                    }


                    // style the drawer colors
                    var modulo = true;
                    if (i % 2 > 0) {
                        modulo = false;
                    }

                    // store your mbrID w/AP + umi
                    var mbrID = alphaPrefix + umi;


                    // if for whatever reason we don't get data, we want to be sure code doesn't break.

                    if(i > $scope.PCPData.length - 1) {
                        var PCPHolder = {
                            "PCPNumber" : "",
                            "PCPName" : "" };
                        $scope.PCPData.push(PCPHolder);
                    }

                    // PCP number is undefined as a service call back if account has expired/cancelled.
                    // we want to flag a boolean if this is the case so that submit is never enabled
                    // because it will fail.

                    if(typeof $scope.PCPData[i].PCPNumber == "undefined")  {
                        cancelledAccount = true;
                        $scope.PCPData[correctPCPMemberIndex].PCPNumber = "";
                        $scope.PCPData[correctPCPMemberIndex].PCPName = "";
                    }
                    else {
                        cancelledAccount = false;
                    }


                    // ternary that figures if the member has a PCP or not.
//			var hasPOR = (!PCPData[correctPCPMemberIndex].PCPNumber || !providerSelected ) ? false : true;
                    var hasPOR = ( !$scope.PCPData[correctPCPMemberIndex].PCPNumber ) ? false : true;

                    // Build your member object for iteration in the html

                    var mbr = {
                        "relationship" : mbrList[i].relationship,
                        "firstName" : mbrList[i].firstName,
                        "lastName" : mbrList[i].lastName,
                        "dob" : mbrList[i].dob,
                        "lob" : mbrLOB,
                        "cancelCheck" : false,
                        physician: {
                            name: $scope.PCPData[correctPCPMemberIndex].PCPName,
                            id: $scope.PCPData[correctPCPMemberIndex].PCPNumber,
                            newID: '',
                            currentClientIsEmpty: false,
                            currentClient:"no",
                            reasonIsEmpty: false,
                            reason:""
                        },
                        "drawerOpen" : false,
                        "modulo" : modulo,
                        "mbrID" : mbrID,
                        "ciid" : mbrList[i].ciid,
                        "hasPOR" : hasPOR,
                        "isSubmitted": false,
                        "cancelSubmitted" : false,
                        "showInput": !hasPOR,
                        "showCancel" : false,
                        "submitDisabled": true,
                        "cancelDisabled" : !hasPOR,
                        "showable" : showable,
                        submission: {
                            msg: "",
                            status: false,
                            fail : false
                        },
                        "showPvdLinkMN" : (sessionData && sessionData.appConfig && sessionData.appConfig.ACCOUNT_SETTINGS && sessionData.appConfig.ACCOUNT_SETTINGS.SHOW_PVD_LINK && sessionData.appConfig.ACCOUNT_SETTINGS.SHOW_PVD_LINK.booleanValue) ? true : false,
                        "mnBrand" : (piBrand.toLowerCase()) === "mincr" ? true : false
                    };
                    // push the object onto the member array
                    mbrArr.push(mbr);
                }


                // if we are coming from PRISM - we need to change the model subtly
                //	format is: mbr/#!/account/por?PCPNumber=999999999&PCPNAME=Doc Holiday&PCPIndex=2

                if(typeof PCPIndex != "undefined") {
                    if(PCPDocNamefromPRISM) {
                        PCPDocNamefromPRISM = decodeURIComponent(PCPDocNamefromPRISM);
                    }
                    // If PCPIndex is off kilter, let's make it 1 to open the first drawer
                    if (PCPIndex === "0" || PCPIndex > mbrArr.length) {
                        PCPIndex = 1;
                    }
                    mbrArr[0].drawerOpen = true;
                    mbrArr[PCPIndex-1].drawerOpen = true;
                    mbrArr[PCPIndex-1].physician.id = PCPfromPRISM;
                    mbrArr[PCPIndex-1].physician.name = PCPDocNamefromPRISM;
                    mbrArr[PCPIndex-1].physician.newID = PCPfromPRISM;
                    mbrArr[PCPIndex-1].submitDisabled = false;
                    mbrArr[PCPIndex-1].showInput = true;
                }


                // plug your array of member objects into the model
                $scope.members = mbrArr;

                // open the top drawer
                if(typeof PCPIndex == "undefined") {
                    $scope.members[0].drawerOpen = true;
                }

                var PCP = $cookies.get("PCP");


            };
;


            var setSidebar =function(){
                $scope.pcpCheck = ($cookies.get("PCP") == "true") ? true : false;
                if($scope.pcpCheck) {
                   var heading = "<img src= '/content/dam/generic/en/healthco/images/account/POR1.png'/ >"
                    var description = "<p class='por-side-heading-content' data-aem-content='PCP_SIDEBAR_HEADING_1'></p> <p data-aem-content='PCP_SIDEBAR_P_1'></p><br><p class='por-side-heading-content' data-aem-content='PCP_SIDEBAR_HEADING_2'></p> <p data-aem-content='PCP_SIDEBAR_P_2'></p><br>" +
                        "<p class='por-side-heading-content' data-aem-content='PCP_SIDEBAR_HEADING_3'></p> <p data-aem-content=' PCP_SIDEBAR_P_3'></p>"

                } else {
                    var heading = "<img src= '/content/dam/generic/en/healthco/images/account/POR1.png'/ > <p class='por-side-heading-content' data-aem-content='MER_POR_SIDEBARHEADING_01'></p> <p class='por-side-heading-content' data-aem-content='MER_POR_SIDEBARHEADING_02'></p>"
                    var description = "<p class='margin-top' data-aem-content='MER_POR_SIDEBAR_CONTENT_01'></p> <p class='margin-top' data-aem-content='MER_POR_SIDEBAR_CONTENT_02'></p>" +
                        "<p class='margin-top' data-aem-content='MER_POR_SIDEBAR_CONTENT_03'></p><p class='margin-top' data-aem-content='MER_POR_SIDEBAR_CONTENT_04'></p>"

                }

                $scope.sidebar.links.push({
                    heading: heading,
                    description: description

                });

            };

            setSidebar();

        }
    ]);
    app.directive("limitTo", [function() {
        return {
            restrict: "A",
            link: function(scope, elem, attrs) {
                var limit = parseInt(attrs.limitTo);
                angular.element(elem).on("keypress", function(e) {
                    if (this.value.length == limit) e.preventDefault();
                });
            }
        };
    }]);
}